/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';

import AlignmentView from 'analyses/alignment/AlignmentView';
import CreateAssemblyLink from 'assembly/CreateAssemblyLink';
import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import CreateSourceHashView from 'create-components/CreateSourceHashView';
import CreateExportHashView from 'create-components/CreateExportHashView';
import CreateCRISPRLink from 'molbio/crispr/CreateCRISPRLink';
import CreateHRTemplateLink from 'molbio/crispr/CreateHRTemplateLink';
import SpreadsheetBulkImportLink from 'bulk-import/SpreadsheetBulkImportLink';
import DataRecoveryHashView from 'notebook/store/data-recovery/DataRecoveryHashView';
import CreateFolderModal from 'folders/CreateFolderModal';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import getFolderPath from 'folders/util/getFolderPath';
import BatchSequenceImportView from 'import-sequence/backbone/BatchSequenceImportView';
import ImportSequenceHashView from 'import-sequence/backbone/ImportSequenceHashView';
import ImportSequenceModalClass from 'import-sequence/ImportSequenceModal';
import {DNA_SEQUENCE_IMPORT_FLOW} from 'molbio/MolBioConstants';
import listFolderSection from 'nav/sidepanel/listFolderSection';
import TemplateUtil from 'notebook/entry-templates/TemplateUtil';
import notifications from 'notifications';
import CreateImportOligoView from 'molbio/oligos/CreateImportOligoView';
import {openImportProteinModal} from 'molbio/proteins/ImportProteinModal';
import ProteinActions from 'molbio/proteins/ProteinActions';
import * as ModalContainer from 'ui-library/ModalContainer';
import runModal from 'ui-library/runModal';
import CreateTemplateModal from 'notebook/entry-templates/CreateTemplateModal';
import ifCreateFromHash from 'util/ifCreateFromHash';

import CreateEntryModalClass from './CreateEntryModal';
import CreateProtocolModalClass from './CreateProtocolModal';

const {INVENTORY_SECTION} = FileBrowserConstants;

class CreateFromHashView extends Backbone.View {
  bindTemplateCreate(linkSelector, anchor) {
    function callback() {
      ModalContainer.open(
        CreateTemplateModal,
        <CreateTemplateModal
          onRequestClose={() => {
            $('#fileLoading').addClass('hidden');
            ModalContainer.close(CreateTemplateModal);
          }}
          onSubmit={(name, templateCollection, isProtected, tagSchema, schemaTags) => {
            TemplateUtil.createThenOpen(name, templateCollection.id, isProtected, tagSchema, schemaTags).done(
              () => {
                $('#fileLoading').addClass('hidden');
                ModalContainer.close(CreateTemplateModal);
              }
            );
          }}
        />
      );
    }

    $(document).on('click', linkSelector, (e) => {
      e.preventDefault();
      callback();
    });

    ifCreateFromHash(anchor, callback);
  }

  bindFolderCreate(linkSelector, anchor) {
    function callback() {
      ModalContainer.open(
        CreateFolderModal,
        <CreateFolderModal
          onRequestClose={() => ModalContainer.close(CreateFolderModal)}
          successCallback={(newFolder) => {
            listFolderSection(newFolder, INVENTORY_SECTION);
          }}
        />
      );
    }

    $(document).on('click', linkSelector, (e) => {
      e.preventDefault();
      callback();
    });

    ifCreateFromHash(anchor, callback);
  }

  bindBasicCreate(linkSelector, anchor, modalCls, props, useRunModal = false) {
    if (props == null) {
      props = {};
    }
    const callback = useRunModal ? () => runModal(modalCls, props) : () => modalCls.open(modalCls, props);

    $(document).on('click', linkSelector, (e) => {
      e.preventDefault();
      callback();
    });

    ifCreateFromHash(anchor, callback);
  }

  render() {
    new AlignmentView().render();
    this.bindBasicCreate(
      '.js-create-new-sequence',
      '#create/sequence',
      ImportSequenceModalClass,
      {
        initialTab: DNA_SEQUENCE_IMPORT_FLOW.RAW,
      },
      true
    );
    new BatchSequenceImportView().render();
    new CreateCRISPRLink().render();
    new CreateHRTemplateLink().render();
    new SpreadsheetBulkImportLink().render();
    new CreateAssemblyLink().render();
    new ImportSequenceHashView().render();

    function onCreateEntry({folder}) {
      notifications.success(
        <>
          Created entry in <strong>{folder.source.name}</strong>.
        </>
      );
    }

    this.bindBasicCreate('.js-create-new-entry', '#create/entry', CreateEntryModalClass, {
      onCreate: onCreateEntry,
    });
    new CreateImportOligoView().render();

    function onCreateProtcol(protocol) {
      const folderPath = getFolderPath(protocol.folder);
      notifications.success(
        <>
          Created protocol in <strong>{folderPath}</strong>.
        </>
      );
    }

    this.bindBasicCreate('.js-create-new-protocol', '#create/protocol', CreateProtocolModalClass, {
      onCreate: onCreateProtcol,
    });

    // It is possible that this "create protein" code is not actually doing anything, because:
    //   * It does not call `bindBasicCreate`
    //   * `js-create-new-protein` does not appear elsewhere in the codebase
    //   * The expected URL hash "#create/protein" does not work
    // If you confirm that this is the case, then delete this code.
    $(document).on('click', '.js-create-new-protein', (e) => {
      e.preventDefault();
      ProteinActions.promptCreateAndOpen(FolderDefaults.get(FolderDefaultsKey.INVENTORY));
    });

    // It is possible that this "import protein" code is not actually doing anything, because:
    //   * It does not call `bindBasicCreate`
    //   * `js-import-proteins` does not appear elsewhere in the codebase
    //   * The expected URL hash "#import/proteins" does not work
    // If you confirm that this is the case, then delete this code.
    $(document).on('click', '.js-import-proteins', (e) => {
      e.preventDefault();
      openImportProteinModal({});
    });

    new CreateSourceHashView().render();
    new CreateExportHashView().render();
    new DataRecoveryHashView().render();
    this.bindTemplateCreate('.js-create-template', '#create/template');
    this.bindFolderCreate('.js-create-new-folder', '#create/folder');
    return this;
  }
}

export default CreateFromHashView;
